import PropTypes from 'prop-types';
import React from 'react';

import { IMG_LOGO_URL } from 'common/configuration/constants';

const Message = ({ level, children, onClick }) => {
  return (
    <div className={'message ' + level}>
      <div className="message-container">
        <img
          className="message-logo hidden-sm"
          width="65"
          height="75"
          src={IMG_LOGO_URL}
        />
        {children}
      </div>
      <span className="message-close icon icon-cross" onClick={onClick} />
    </div>
  );
};

Message.propTypes = {
  level: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func.isRequired
};

Message.defaultProps = {
  level: 'info',
  children: null
};

export default Message;
